import React, { Fragment, useState, useEffect, useRef } from 'react'
import { Card, Modal, Form, Row, Col, Container, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaSearch } from "react-icons/fa";
import Procesos from './procesos';
import { LoadingComponent } from 'recupero-comunes';
import { useSelector } from 'react-redux';
import { serviceGetCfgForm, serviceGetInforme } from '../../../../../api/api-confirmar-cierre';
import { descargarArchivo } from '../../../../../common/descargarArchivo';



const DetalleCierre = ({ showModal, setShowModal, implicado, solicitud, idProcesoJud }) => {
    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer);
    const { llaves } = data_encargado;
    const [loading, setLoading] = useState(false);
    const [cfg_form, setCfg_form] = useState(null);

    useEffect(() => {
        if (showModal) getCfgForm();
    }, [showModal])

    const getCfgForm = async () => {
        const query = Buffer.from(JSON.stringify({ rutcia: llaves.idOrgCaso, idform: 55 })).toString('base64');
        const response = await serviceGetCfgForm(query);

        setCfg_form(response);
    }

    const handleShowInforme = async () => {
        if (solicitud.folioCarga) {
            setLoading(true);
            let query = Buffer.from(JSON.stringify({
                idCaso: llaves?.idCaso,
                idImplicadoCaso: implicado,
                idCompania: llaves?.idOrgCaso,
                idfolioCarga: solicitud?.folioCarga
            })).toString('base64')

            const response = await serviceGetInforme(query);
            setLoading(false);

            descargarArchivo(response);
        }
    }

    return (
        <Fragment>
            <LoadingComponent show={loading} />

            <Modal show={showModal} onHide={setShowModal} size='xl'>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                        {cfg_form && cfg_form["modalconsultacierre-title"]}
                    </Card.Header>

                    <Card.Body>
                        <Container>
                            <Row>
                                <Col md='12'>
                                    <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                        {cfg_form && cfg_form["modalconsultacierre-lbl-situacion"]}:
                                    </Form.Label>
                                    <span> {solicitud?.motivoSolDcto}</span>
                                </Col>

                                <Col md='7' style={{ marginRight: '30px' }}>
                                    <Form.Label className='mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                        {cfg_form && cfg_form["modalconsultacierre-lbl-comentario"]}
                                    </Form.Label>
                                    <Form.Control
                                        readOnly
                                        as="textarea"
                                        rows={3}
                                        name='comentarioSolDcto'
                                        value={solicitud?.comentarioSolDcto}
                                    />
                                </Col>
                                <Col md='1' style={{ width: '5%', marginTop: '36px' }}>
                                    <OverlayTrigger overlay={<Tooltip id='tooltip-disabled'>{solicitud?.folioCarga ? "Ver Informe de Cierre" : "No existe Informe"}</Tooltip>}>
                                        <Button className='' variant='info'>
                                            <FaSearch
                                                size={20}
                                                color='white'
                                                onClick={handleShowInforme}
                                            />
                                        </Button>
                                    </OverlayTrigger>
                                </Col>
                                <Col md='2' style={{ marginTop: '34px' }}>
                                    <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                        {cfg_form && cfg_form["modalconsultacierre-lbl-lupa"]}
                                    </Form.Label>
                                </Col>
                            </Row>
                        </Container>

                        <Procesos cfg_form={cfg_form} idProcesoJud={idProcesoJud} />
                    </Card.Body>

                    <Card.Footer style={{ display: 'flex', justifyContent: 'right', gap: '8px' }}>
                        <Button className='w-auto' variant='outline-info' onClick={() => setShowModal(false)}>
                            {cfg_form && cfg_form["modalconsultacierre-btn-volver"]}
                        </Button>
                    </Card.Footer>
                </Card>
            </Modal>
        </Fragment>
    )
}

export default DetalleCierre